module.exports = __webpack_public_path__ + "04_short_beige.6498768f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_short_beige.png
// module id = Dtm/
// module chunks = 0